/**
 * @generated SignedSource<<b5c5e7d0a42681f199a252888e970d81>>
 * @relayHash aeeec9baadc4d3044ea8b0e4352bc8d5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/554.0.0-2026-04-08T14:49:45.172Z/usePartialItemsQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageDisplayEnum = "auctionsSearchAndBrowse" | "cart" | "catalog" | "checkout" | "email" | "favorites" | "homepage" | "mc" | "pdp" | "publication" | "searchAndBrowse" | "similarSold" | "visuallySimilar" | "%future added value";
export type usePartialItemsQuery$variables = {
  fetchTileVideo: boolean;
  isTrade: boolean;
  itemIds: ReadonlyArray<string | null>;
  medianL3SoldItemPriceScores: ReadonlyArray<number | null>;
  pageDisplayEnum?: PageDisplayEnum | null;
  personalizationTypes: ReadonlyArray<string | null>;
  priceBookName?: string | null;
  showSeller: boolean;
  userCountryCode?: string | null;
};
export type usePartialItemsQuery$data = {
  readonly viewer: {
    readonly itemSearchInflateItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly item: {
            readonly isPartialItem: boolean | null;
            readonly serviceId: string | null;
            readonly " $fragmentSpreads": FragmentRefs<"FavoritesProvider_item" | "SharedItemTile_item" | "useItemShippingPrices_item" | "useSbSharedItemTracking_item" | "useSharedUrgencySignals_item">;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  };
};
export type usePartialItemsQuery = {
  response: usePartialItemsQuery$data;
  variables: usePartialItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchTileVideo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "medianL3SoldItemPriceScores"
},
v4 = {
  "defaultValue": "searchAndBrowse",
  "kind": "LocalArgument",
  "name": "pageDisplayEnum"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personalizationTypes"
},
v6 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showSeller"
},
v8 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v9 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  },
  {
    "kind": "Variable",
    "name": "medianL3SoldItemPriceScores",
    "variableName": "medianL3SoldItemPriceScores"
  },
  {
    "kind": "Variable",
    "name": "personalizationTypes",
    "variableName": "personalizationTypes"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPartialItem",
  "storageKey": null
},
v12 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v13 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallPath",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webPath",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePartialItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "ItemSearchInflateItemsQueryConnection",
            "kind": "LinkedField",
            "name": "itemSearchInflateItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSearchInflateItemsQueryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchResult",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FavoritesProvider_item"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "useSharedUrgencySignals_item"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "useItemShippingPrices_item"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "useSbSharedItemTracking_item"
                          },
                          {
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "fetchVideo",
                                "variableName": "fetchTileVideo"
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "showSeller",
                                "variableName": "showSeller"
                              }
                            ],
                            "kind": "FragmentSpread",
                            "name": "SharedItemTile_item"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePartialItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "ItemSearchInflateItemsQueryConnection",
            "kind": "LinkedField",
            "name": "itemSearchInflateItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSearchInflateItemsQueryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchResult",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ecommerceTrackingParams",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isOnHold",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSold",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnavailable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isAccessible",
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuotes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentServiceMethod",
                                "kind": "LinkedField",
                                "name": "serviceMethod",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Region",
                                    "kind": "LinkedField",
                                    "name": "region",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "code",
                                        "storageKey": null
                                      },
                                      (v14/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "regionName",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v14/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isComplimentary",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCalculated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "totalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "kind": "LinkedField",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "USD",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": "displayPriceTracking",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "catchNonFatalErrors",
                                "value": false
                              },
                              (v12/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "page",
                                "variableName": "pageDisplayEnum"
                              },
                              (v13/*: any*/),
                              {
                                "kind": "Variable",
                                "name": "userCountryCode",
                                "variableName": "userCountryCode"
                              }
                            ],
                            "concreteType": "ItemDisplayPriceType",
                            "kind": "LinkedField",
                            "name": "displayPrice",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "address",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "englishCountryName",
                                "storageKey": null
                              },
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "medianL3SoldItemPriceScore",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "categoryCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "browseUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contemporaryTrackingString",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isNewListing",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "personalizationType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "vertical",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "localizedPdpUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemMeasurement",
                            "kind": "LinkedField",
                            "name": "measurement",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "addLabel",
                                    "value": true
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "fields",
                                    "value": [
                                      "height",
                                      "width",
                                      "depth",
                                      "diameter",
                                      "length"
                                    ]
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "separator",
                                    "value": " "
                                  }
                                ],
                                "concreteType": "ItemDisplayMeasurementType",
                                "kind": "LinkedField",
                                "name": "display",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unit",
                                    "storageKey": null
                                  },
                                  (v19/*: any*/)
                                ],
                                "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSize",
                                "kind": "LinkedField",
                                "name": "size",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemClassification",
                            "kind": "LinkedField",
                            "name": "classification",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "creationDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemCreator",
                            "kind": "LinkedField",
                            "name": "creators",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Creator",
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v14/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMultiSku",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRingItem",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VariableAttribute",
                            "kind": "LinkedField",
                            "name": "variableAttributes",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VariableAttributeSortType",
                                "kind": "LinkedField",
                                "name": "variableAttributeData",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SwatchSort",
                                    "kind": "LinkedField",
                                    "name": "swatchSort",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Swatch",
                                        "kind": "LinkedField",
                                        "name": "swatch",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v20/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageUrl",
                                            "storageKey": null
                                          },
                                          (v14/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v12/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "page",
                                "value": "searchAndBrowse"
                              },
                              (v13/*: any*/)
                            ],
                            "concreteType": "ItemDisplayPriceType",
                            "kind": "LinkedField",
                            "name": "displayPrice",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConvertedAmountList",
                                "kind": "LinkedField",
                                "name": "originalConvertedAmountList",
                                "plural": true,
                                "selections": (v15/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quantityDisplay",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percentageOff",
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showPriceLabel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showPriceVariability",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "QuickViewDisplayType",
                            "kind": "LinkedField",
                            "name": "quickViewDisplay",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuickViewParagraph",
                                "kind": "LinkedField",
                                "name": "paragraphs",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "key",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "mobileText",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "formatType",
                                        "value": "MOBILE"
                                      }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": "text(formatType:\"MOBILE\")"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuickViewCreator",
                                "kind": "LinkedField",
                                "name": "creators",
                                "plural": true,
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuickViewCategorySegments",
                                "kind": "LinkedField",
                                "name": "paragraphAttributeNames",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "period",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "origin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "style",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "periodPrefix",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "carouselPhotos",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 2
                              }
                            ],
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "masterOrZoomPath",
                                "storageKey": null
                              },
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": "photos(limit:2)"
                          },
                          {
                            "alias": "productPhotos",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 1
                              }
                            ],
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": [
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": "photos(limit:1)"
                          },
                          (v14/*: any*/),
                          {
                            "condition": "showSeller",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Seller",
                                "kind": "LinkedField",
                                "name": "seller",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SellerProfile",
                                    "kind": "LinkedField",
                                    "name": "sellerProfile",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "company",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "condition": "fetchTileVideo",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasApprovedVideo",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/554.0.0-2026-04-08T14:49:45.172Z/usePartialItemsQuery",
    "metadata": {},
    "name": "usePartialItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "305a48b21d7337c48df61903f24120d5";

export default node;
